export default defineNuxtRouteMiddleware(async () => {
  const supabase = useSupabaseClient()
  const { data: { session } } = await supabase.auth.getSession()

  // Require authentication
  if (!session) {
    return navigateTo('/auth/login')
  }

  // Verify super admin status
  try {
    const res = await $fetch('/api/super-admin/verify', {
      method: 'GET',
      retry: 1,
    })

    if (!res?.is_super_admin) {
      return navigateTo('/unauthorized')
    }
  }
  catch (error) {
    console.error('Super admin verification failed:', error)
    return navigateTo('/unauthorized')
  }
})
